// ============================================================
//  src/admin/pages/services/AdminServicesPage.js
//  Hub page — links to all service sub-pages
// ============================================================
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SectionHeader, AdminCard } from '../../components/AdminUI';
import { ADMIN_BASE } from '../../adminConfig';

const CARDS = [
  {
    to: `${ADMIN_BASE}/services/data-plans`,
    icon:  'fa-wifi',
    color: '#4f46e5',
    title: 'Data Plans',
    desc:  'Manage data bundles, pricing and availability per network',
  },
  {
    to: `${ADMIN_BASE}/services/airtime`,
    icon:  'fa-phone',
    color: '#f59e0b',
    title: 'Airtime',
    desc:  'Configure airtime top-up settings and network options',
  },
  {
    to: `${ADMIN_BASE}/services/cable`,
    icon:  'fa-tv',
    color: '#0ea5e9',
    title: 'Cable TV',
    desc:  'Manage Cable TV bouquets, decoders and subscription settings',
  },
  {
    to: `${ADMIN_BASE}/services/electricity`,
    icon:  'fa-bolt',
    color: '#f97316',
    title: 'Electricity',
    desc:  'Configure electricity distribution companies and billing',
  },
  {
    to: `${ADMIN_BASE}/services/exam`,
    icon:  'fa-graduation-cap',
    color: '#8b5cf6',
    title: 'Exam',
    desc:  'Manage exam PIN purchases for WAEC, NECO, JAMB and more',
  },
  {
    to: `${ADMIN_BASE}/services/cashback`,
    icon:  'fa-percent',
    color: '#10b981',
    title: 'Cashback',
    desc:  'Set up and manage cashback rewards for subscriber transactions',
  },
];

export default function AdminServicesPage() {
  const navigate = useNavigate();
  return (
    <div>
      <SectionHeader title="Services" subtitle="Manage all your service offerings and configurations" />
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
        gap: 16,
        marginTop: 8,
      }}>
        {CARDS.map((c) => (
          <AdminCard
            key={c.to}
            style={{ cursor: 'pointer', transition: 'box-shadow 0.18s, transform 0.15s' }}
            onClick={() => navigate(c.to)}
            onMouseEnter={e => { e.currentTarget.style.transform='translateY(-3px)'; e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.10)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow=''; }}
          >
            <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:10 }}>
              <div style={{
                width:44, height:44, borderRadius:12,
                background: c.color+'18', color: c.color,
                display:'flex', alignItems:'center', justifyContent:'center',
                fontSize:18, flexShrink:0,
              }}>
                <i className={`fas ${c.icon}`} />
              </div>
              <div>
                <div style={{ fontWeight:800, fontSize:15, color:'var(--text-dark)' }}>{c.title}</div>
                <div style={{ fontSize:12, color:'var(--text-light)', marginTop:2, lineHeight:1.4 }}>{c.desc}</div>
              </div>
            </div>
            <div style={{ fontSize:12, color: c.color, fontWeight:700, display:'flex', alignItems:'center', gap:5 }}>
              Open <i className="fas fa-arrow-right" style={{fontSize:10}} />
            </div>
          </AdminCard>
        ))}
      </div>
    </div>
  );
}